import React, { Suspense, useMemo } from 'react';
import { Redirect, Switch, useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import { SpecificationsUIProvider } from '../../../../_metronic/layout/components/basePage/insidePages/SpecificationsUIContext';
import { Specifications } from '../../../../_metronic/layout/components/basePage/insidePages/Specifications';

import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './FloorReportUtils';


export const FloorReportPage = () => {
  const { currentState } = useSelector(
    (state) => ({ currentState: state.floorReports }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/floorReport")) {
    const temp = menuList.find(q => q.url == "/floorReport")
    isFullAccess = temp.isFullAccess;
  }

  return (

    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          <ContentRoute
            path="/floorReport"
            render={props =>
              <ObjectsPage
                filterByShowButton={true}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/floorReport"
                api="api/Floor"
                getFunctionName="GetAllFloors"
                exportfuncName="GetAllFloorsExcel"
                currentState={currentState}
                columns={columns}
                prepareFilter={prepareFilter}
                filterFields={filterFields}
                filterInitialValues={filterInitialValues}
                enablePagination={false}
                haveExportButton={true}

                haveStimulsoftReport={true}
                mrtUrl="/reports/FloorRoomCountReports.mrt"
                jsonFileName="GetFloorsReport"
              />
            }
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>


  )
}

export default FloorReportPage



